<template>
  <div>
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header p-2">
            <h6 class="modal-title">{{ messageTitle }}</h6>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeDialog()">
              <span aria-hidden="true">
                <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;">
                </cancel-icon>
              </span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="h-100">
              <div style="padding: 6px 10px;" :style="(jobStatusInfo && jobStatus == 'FAILED')?'color:#dc3545':'color:#eee !important'">
                <strong>{{ messageType }}</strong>
                {{ alertMessage }}
              </div>
              <template v-if = "jobStatusInfo && jobStatus != 'FAILED'">
                <div class="progress" style="height: 15px;border-radius: 5px;margin-top: 4px;background-color: rgb(197, 197, 197);margin-inline-start: 10px;">
                    <div class="progress-bar" role="progressbar" style="border-radius: 4px;"
                      :aria-valuenow='progressValue' aria-valuemin="0" aria-valuemax="100" :style="{width:progressValue + '%'}">
                    </div>
                </div>
              </template>
            </div>
          </div>
          <div class="modal-footer" style="display: inline-flex;">
            <!-- <div class="p-0 primary-btn-style" style="margin: 0px !important;display: inline-flex;justify-content: end;">
              <button class="btn btn-outline-secondary mr-3" v-show="$route.name != 'blaze_fusion_browse'" data-dismiss="modal" @click="close">Cancel</button>
              <button class="btn btn-outline-primary mr-3" @click='handleFileSelection()'>Add</button>
            </div> -->
            <template v-if="getUserConfirmation">
              <template v-if="forFusionCutConfig">
                <button @click="allowUpdation()" data-dismiss="modal" class="btn btn-outline-secondary mr-2">{{$t('Change import settings')}}</button>
                <button type="button" class="btn btn-outline-primary ml-1" @click="closeDialog()" :style="buttonStyle">
                  {{$t('Keep existing settings')}}
                </button>
              </template>
              <template v-else>
                <button @click="closeDialog()" data-dismiss="modal" class="btn btn-outline-secondary mr-2">Cancel</button>
                <button type="button" class="btn btn-outline-primary ml-1" @click="allowDeletion()" :style="buttonStyle">
                  <template v-if="deleteButtonText">{{deleteButtonText}}</template>
                  <template v-else>{{$t('Delete')}}</template>
                </button>
              </template>
            </template>
            <template v-else>
              <button v-if="isDatasetTrainReq" type="button" class="btn btn-outline-primary ml-1" @click="forceTrainDataset()">
                {{$t('Train Dataset')}}
              </button>
              <button v-else type="button" class="btn btn-outline-primary ml-1" @click="closeDialog()">
                {{$t('Ok')}}
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CancelIcon from "../core/InlineCancelField.vue";

export default {
  props:["messageTitle","messageType","displayMessage","getUserConfirmation","isDatasetTrainReq", "forFusionCutConfig","deleteButtonText", "jobStatusInfo","borderColor","backgroundColor"],
  data: () => ({
    progressValue:0,
    updatedAssetsCount:0,
    totalAssetsCount:0,
    jobStatus:null,
    alertMessage:null
  }),
  components:{
    CancelIcon
  },
  computed: {
    buttonStyle() {
      return {
        "border-color": this.borderColor || '#1d868c !important',
        "background-color": this.backgroundColor || '#1d868c !important',
        "color":"#fff"
      }
    }
  },
  watch:{
    jobStatusInfo(newVal,oldVal){
      console.log("jobStatusInfo : Watch: ", typeof(newVal), typeof(oldVal));
      this.updateJobStatusDetails();
    },
    displayMessage(newVal,oldVal){
      console.log("jobStatusInfo : Watch: ", typeof(newVal), typeof(oldVal));
      this.alertMessage = this.displayMessage;
    }
  },
  methods:{
      closeDialog(){
          this.$emit("close");
      },
      forceTrainDataset(){
        this.$emit('forceTrainDataset')
      },
      allowUpdation(){
        this.$emit("allowUpdation");
      },
      allowDeletion(){
        this.$emit("allowDeletion");
      },
      updateJobStatusDetails(){
        if(this.jobStatusInfo && Object.keys(this.jobStatusInfo).length > 0){
          if('status_info' in this.jobStatusInfo && 'progress' in this.jobStatusInfo['status_info']){
            let statusDetails = this.jobStatusInfo ['status_info'];
            this.progressValue = statusDetails['progress'];
            if(Object.keys(statusDetails).includes("updated_assets_count")){
                this.updatedAssetsCount = statusDetails["updated_assets_count"];
            }
            if(Object.keys(statusDetails).includes("total_assets_count")){
              this.totalAssetsCount = statusDetails["total_assets_count"];
            }
            if('state' in this.jobStatusInfo){
              this.jobStatus = this.jobStatusInfo['state'];
            }
            if(this.jobStatus == 'FAILED'){
              this.alertMessage = "Failed to unset the field values."
            }else{
              this.alertMessage = this.$t(`Unsetting ${this.updatedAssetsCount} out of ${this.totalAssetsCount}`);
            }
          }
        }else{
          this.progressValue = 0;
          this.updatedAssetsCount = 0;
          this.totalAssetsCount = 0;
          this.jobStatus = null;
        }
      }
  },
  created(){
    if(this.displayMessage){
      this.alertMessage = this.displayMessage;
    }
    this.updateJobStatusDetails();
  }
}
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;

::v-deep{
    .v-card__title, .v-card__actions{
        background: $secondary-background-color !important;
        padding:8px;
        border-bottom: $secondary-border-color;
    }
    .v-card__text{
        background: $primary-background !important;
    }

    .v-card__actions{
        border-top: $secondary-border-color;
    }
    .save-btn.v-btn--outlined {
        border: thin solid #007bff;
    }

    .theme--dark.v-btn.v-btn--outlined.v-btn--text {
        border-color: #007bff;
    }

    .v-card.v-sheet.theme--dark{
        border: $secondary-border-color;
    }

    .v-text-field__slot{
        margin-inline-start:-10px;
    }
     .v-text-field {
        input {
                margin-inline-start: 12px;
                margin-top: 16px;
                color:$text-color
        }
     }
}

svg{
    fill:$svg-color;
}
.primary-btn-style {
  justify-content: flex-end;
  margin-top: 1%;
  height:55px;
  button {
    height: 35px;
    width: 70px;
    border-radius: 5px;
    font-size:14px;
  }
}
.secondary-btn-style:hover {
    text-decoration: underline;
}

.input-fields {
  border: none !important;
  border-bottom: 1px solid #007bff !important;
  height:30px;
}

.input-fields:focus {
  outline: unset;
  box-shadow:none;
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
  fill:$text-color;
}
.modal-dialog {
        max-width: 500px !important;
        width: 500px !important;
        // height: 60% !important;
        margin: 0;
        padding: 0;
    }
  
    .modal-content {
        height: auto !important;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            height: 90px;
            overflow: auto;
            padding: 1rem !important;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: inline-flex;
        position: fixed;
        align-items: center;
        justify-content: center;
        
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height:45px;
        align-items: center;
        .modal-title{
            color:$text-color;
            padding: 0px;
            // height:45px;
            line-height: 4px;
        }
    }
    .modal-footer{
      height:50px;
      padding: 0px 5px !important;
      .btn{
        padding: 3px 10px !important;
      }
    }

    .modal-header .close {
        margin: 0px !important;
        padding: 0px !important;
    }
</style>